import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

const getSelectedVoucher = (
  vouchers: GetEligibleCampaignsResponseType[] = [],
  loyaltyCampaignId: string
): GetEligibleCampaignsResponseType | undefined => {
  return vouchers.length
    ? vouchers.find((item: GetEligibleCampaignsResponseType) => item.campaign_id === loyaltyCampaignId)
    : undefined;
};

export default getSelectedVoucher;
